import { graphql } from '@search/gql-client/src/useGql';

export const TrackOfferMutation = graphql`
    mutation TrackOfferMutation($offerId: ID!, $countryCode: String, $number: String, $isPhone: Boolean) {
        trackOffer(offerId: $offerId, countryCode: $countryCode, number: $number, isPhone: $isPhone) {
            success
        }
    }
`;
